import { DeviceInfo } from "../types";
import { ChipStatus } from "../../../../common/enums";

export const sortDevicesByDate = (currentItem: DeviceInfo, nextItem: DeviceInfo) => {
  if (!currentItem.authenticatedDate && !nextItem.authenticatedDate) {
    if (new Date(nextItem.createdDate) < new Date(currentItem.createdDate)) {
      return -1;
    } else if (new Date(nextItem.createdDate) > new Date(currentItem.createdDate)) {
      return 1;
    } else return 0;
  }
  if (new Date(nextItem.authenticatedDate) < new Date(currentItem.authenticatedDate)) {
    return -1;
  } else if (new Date(nextItem.authenticatedDate) > new Date(currentItem.authenticatedDate)) {
    return 1;
  } else return 0;
};

export const filterByValidDeviceName = ({ deviceName }: DeviceInfo) => Boolean(deviceName);

export const sortDevices = (deviceA: DeviceInfo, deviceB: DeviceInfo) => {
  const displayOrderCriteria = [ChipStatus.ACTIVE, ChipStatus.DEACTIVATED, ChipStatus.INACTIVE];
  const indexOfDeviceA = displayOrderCriteria.indexOf(deviceA.status.toLowerCase() as ChipStatus);
  const indexOfDeviceB = displayOrderCriteria.indexOf(deviceB.status.toLowerCase() as ChipStatus);
  if (indexOfDeviceA < indexOfDeviceB) {
    return -1;
  } else if (indexOfDeviceA > indexOfDeviceB) {
    return 1;
  } else return sortDevicesByDate(deviceA, deviceB);
};
